/**
 * MedicalInfoStep.validation.js
 *
 * Pure function, no React — mirrors LifestyleStep.validation.js /
 * ActivityLevelStep.validation.js. MedicalInfoStep only consumes
 * `isValid` to drive AssessmentStepShell's `nextDisabled`; `errors` is
 * returned too in case a future screen wants field-level messaging.
 */

import { MEDICATIONS_MAX_LENGTH } from "./MedicalInfoStep.constants";

export function validateMedical(data) {
  const errors = {};

  if (!Array.isArray(data.conditions) || data.conditions.length === 0) {
    errors.conditions = "Please select at least one condition, or choose 'None'.";
  }

  if (typeof data.medications === "string" && data.medications.length > MEDICATIONS_MAX_LENGTH) {
    errors.medications = `Please keep this under ${MEDICATIONS_MAX_LENGTH} characters.`;
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}